import axiosInstance from "../../axiosInstance";

export const createArticle = async (formData) => {
  try {
    const response = await axiosInstance.post(
      "/api/v1/speakers/articles",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getArticles = async (params) => {
  try {
    const response = await axiosInstance.get("/api/v1/speakers/articles", {
      params: {
        Page: params.Page,
        PageCount: params.PageCount,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getArticle = async (articleId) => {
  try {
    const response = await axiosInstance.get(
      `/api/v1/speakers/articles/${articleId}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateArticle = async (articleId, articleData) => {
  try {
    const response = await axiosInstance.put(
      `/api/v1/speakers/articles/${articleId}`,
      articleData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteArticle = async (articleId) => {
  try {
    const response = await axiosInstance.delete(
      `/api/v1/speakers/articles/${articleId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting article:", error);
    throw error;
  }
};
